import React from 'react';
import { getTypeIcon } from '../../../../../utils/fn/medias';

const MediaThumbnail = ({ media, style = {}, iconSize = 24 }) => {
  const containerStyle = {
    width: '100%',
    aspectRatio: '1 / 1',
    backgroundColor: '#f0f0f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    ...style,
  };

  const hasThumbnail =
    (media.cdn_link != null && String(media.cdn_link).trim() !== '') ||
    (media.local_file != null && String(media.local_file).trim() !== '');

  if (media.type === 'image' && hasThumbnail) {
    return (
      <div style={containerStyle}>
        <img
          key={`${media.id}-${media.cdn_link ?? media.local_file}`}
          src={media.cdn_link ?? media.local_file}
          alt={media.name ?? ''}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </div>
    );
  }

  return <div style={containerStyle}>{getTypeIcon(media.type, iconSize)}</div>;
};

export default MediaThumbnail;
